import { useParams } from 'react-router-dom';
import { hari } from '../../contants';

import DetailsComponent from './DetailsComponent';
import styled from 'styled-components';

const HariDetails = () => {
  const { project } = useParams();
  const projectDetails = hari.projects.find((item) => item.name === project);

  const highlightKeywords = (text, keywords) => {
    const regex = new RegExp(`(${keywords.join('|')})`, 'gi');
    return text
      .split(regex)
      .map((part, index) =>
        keywords.includes(part) ? <b key={index}>{part}</b> : part
      );
  };

  const keywords = [
    'Sambandh',
    'MERN application',
    'Uber',
    'JP Morgan',
    'Disney',
    'Amazon',
    'Meta',
    'ExodusPoint Capital Management',
    'lead UI/UX designer and frontend developer',
    'React Native and Redux',
    'Node.js and Express.js',
    'GraphQL for optimized data retrieval',
    'digital cultural hub',
    'Thakorji Darshan',
    'videos, images, and shorts',
    'Hindu calendar',
    'platform with purpose',
    'dedicated digital platform to streamline temple management',
    'track event details, create new events, publish articles, and post event media',
    'schedule, organize, and oversee religious and cultural events',
    'ease of use',
    'technology meets tradition',
    'modern web development with cultural preservation',
  ];

  return (
    <DetailsComponent>
      <Wrapper>
        <Header>{projectDetails.name}</Header>
        <ScreenShotWrapper>
          {projectDetails.screenShotLinks.map((link, index) => (
            <ScreenShot key={index} src={link} alt='error' />
          ))}
        </ScreenShotWrapper>
        <Tags>
          {projectDetails.technologies.map((item, index) => (
            <Tag key={index}>{item}</Tag>
          ))}
        </Tags>
      </Wrapper>
      <Description>
        <ul>
          {projectDetails.description.map((points, index) => (
            <List key={index}>{highlightKeywords(points, keywords)}</List>
          ))}
        </ul>
      </Description>
    </DetailsComponent>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;

const ScreenShot = styled.img`
  border-radius: 32px;
  overflow: hidden;
  filter: drop-shadow(0.05rem 0.1rem 0.1rem rgba(0, 0, 0, 0.2));
  border: 3px solid white;
  background-color: hsl(0, 24%, 96%);
  @media (max-width: 500px) {
    border-radius: 16px;
    filter: drop-shadow(0.05rem 0.1rem 0.1rem rgba(0, 0, 0, 0.1));
  }
`;

const ScreenShotWrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 80%;
  @media (max-width: 500px) {
    width: 350px;
  }
`;

const Header = styled.h1`
  font-family: 'Bashing';
  font-size: calc(70 / 16 * 1rem);
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  margin-bottom: 8px;
  line-height: 68px;
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
`;

const Tag = styled.p`
  background-color: ${({ theme }) => theme.tileBackground};
  height: 36px;
  letter-spacing: 0.5px;
  font-family: 'Raleway';
  font-size: 16px;
  width: fit-content;
  padding: 8px;
  border-radius: 36px;
  display: flex;
  align-items: center;
`;

const Description = styled.div`
  flex: 1;
  font-family: 'Raleway';
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  text-align: left;
`;

const List = styled.ul`
  margin-bottom: 16px;
  font-family: 'Raleway';
  letter-spacing: 0.5px;
  font-weight: 500;
  line-height: 26px;
`;

export default HariDetails;
